<template lang="html">
	<div>
		<div class="row">

			<div class="col resto-selection-city center">

				<div class="resto-sel-city-col" v-for="option in selectOptions" :id="'postal-'+option.value">
					<a href="javascript:;" v-on:click="change_city" :postal="option.value" class="btn-postal btn" :class="[citySelected == option.value ? 'btn-resto-selection-active' : 'btn-resto-selection']" :id="'btn-postal-'+option.value">{{ option.text }}</a>
				</div>

			</div>

			<div class="col resto-city-select">
				<select class="form-control custom-select" v-on:change="change_city" v-model="citySelected">
					<option v-for="option in selectOptions" v-bind:value="option.value">
						{{ option.text }}
					</option>
				</select>
			</div>
		</div>
		<slot></slot>
	</div>
</template>

<script>

export default {

	props: {

		cities: {
			required: true
		},

	},

	data() {
		return {
			citySelected: '1000',
			selectOptions: [],
		}
	},

	mounted() {
		let options = [];
		this.cities.forEach(function(item){
			options.push({ value: item.postal, text: item.name })
		});
		this.selectOptions = options
	},

	methods: {

		change_city: function(e) {
			let postal
			if(e.currentTarget.getAttribute('postal')) {
				postal = e.currentTarget.getAttribute('postal')
				this.citySelected = postal
			} else {
				postal = this.citySelected
			}

			let resto_row = document.getElementsByClassName('resto-city-row')
			for(var i = 0; i < resto_row.length; i++) {
				var element = resto_row[i];
				if(element.classList) {
					element.classList.add('d-none');
				} else {
					element.className += ' ' + 'd-none';
				}
			}
			document.getElementById('postal-row-'+postal).classList.remove("d-none")

			let btns = document.getElementsByClassName('btn-postal')
			for(var i = 0; i < btns.length; i++) {
				var element = btns[i];
				if(element.classList) {
					element.classList.remove('btn-resto-selection-active');
					element.classList.add('btn-resto-selection');
				} else {
					element.className -= ' ' + 'btn-resto-selection-active';
					element.className += ' ' + 'btn-resto-selection';
				}
			}
			e.currentTarget.classList.add('btn-resto-selection-active');
			e.currentTarget.classList.remove('btn-resto-selection')
		},

	}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/RestoSelectionComponent.vue